// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForIndicatorTitle = makeThemedStyles('Range.IndicatorTitle', () => ({
  IndicatorTitle: {
    marginLeft: '0.5rem',
    alignSelf: 'center'
  },

  smallRounded: {
    marginLeft: '0.3em'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const IndicatorTitle: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForIndicatorTitle();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.IndicatorTitle, {
        [styles.smallRounded]: isVariantEnabled(props, 'smallRounded')
      })}
    >
      {props?.children}
    </div>
  );
};
export default IndicatorTitle;
